module.exports = __webpack_public_path__ + "img/shopline-three.e0714981.png";